import PropTypes from 'prop-types'
import { Fragment } from 'react'
import { Link } from 'react-router-dom'

import agent from 'agent'
import { AlertText } from 'components/common/Alert'
import Button from 'components/common/Button'
import ConfirmationModal from 'components/common/ConfirmationModal'
import Text from 'components/common/Text'
import toast from 'lib/toast'
import { track } from 'track'
import { messageFromResponseError } from 'utils/strings'

async function shareScenario(scenarioId, currentTeamId) {
  try {
    track('ScenarioShared', {
      category: 'ScenarioSharing',
      count: 1
    })

    const { data } = await agent.post(
      `scenarios/shared?teamId=${currentTeamId}`,
      [scenarioId]
    )

    const result = data[scenarioId]

    if (result.status !== 'SUCCESS') {
      throw new Error('Failed to create shared scenario')
    }

    toast({
      type: 'success',
      text: (
        <AlertText>This Scenario has been shared with your company. </AlertText>
      ),
      action: (
        <Button
          primary
          as={Link}
          to={`/scenarios/shared/company/${result.sharedId}`}
        >
          View Scenario
        </Button>
      )
    })
  } catch (err) {
    toast({
      type: 'error',
      text: messageFromResponseError(
        err,
        'There was an issue sharing this scenario. Please try again later.'
      )
    })
  }
}

export default function ShareScenarioModal({
  scenarioId,
  currentTeamId,
  open,
  onConfirm,
  onCancel
}) {
  return (
    <ConfirmationModal
      confirmButtonType="primary"
      confirmText="Share"
      message={
        <Fragment>
          <Text as="p">
            Allow any team in your company to copy this Scenario and attack
            their own targets. If you added any Golden Signals the copy will
            include their configurations, headers and success evaluations.
          </Text>
          <br />
          <Text as="p">
            You can unshare from Recommended Scenarios at any time.
          </Text>
        </Fragment>
      }
      open={open}
      title="Share a copy with your company"
      onCancel={onCancel}
      onConfirm={async () => {
        await shareScenario(scenarioId, currentTeamId)
        onConfirm()
      }}
    />
  )
}

ShareScenarioModal.propTypes = {
  open: PropTypes.bool,
  scenarioId: PropTypes.string,
  currentTeamId: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func
}
